module.exports = __webpack_public_path__ + "assets/img/5.87074c5c.png";